import jsapi from './jsapi.json';
import * as dd from 'dingtalk-jsapi';
import http from '../http';
import store from "@/store/index";

const {dingdingAccessKey } = require(`@/config/develop.json`);
let DingFun = async () => {
    let dingding = {
        ddinit() {
            console.log('进来健全了')
            let _this = this;
            return new Promise((resolve, reject) => {
                this.ddReady().then((config) => {
                    if (config.success) {
                        store.commit('setDingDingconfig', config.data);
                        console.log(config.data)
                        _this.ddAuth(config.data.corpId).then(res => {
                            if (res.success) {
                                resolve({ success: true, data: res.data })
                            } else {
                                resolve({ success: false, data: {} });
                            }
                        })
                    } else {                      
                        resolve({ success: false, data: {} });
                    }
                })
            })
        },
        ddAuth(corpId) {
            return new Promise((resolve, reject) => {
                dd.runtime.permission.requestAuthCode({
                    corpId: corpId,
                    onSuccess: async function (result) {
                        console.log(result.code)
                        const getUserResult = await http.get(`api/UserManagement/AutoLogin?code=${result.code}&smallProgram=${dingdingAccessKey}`).then(res => res.data || {});//获取当前登录人userid
                         console.log(getUserResult)
                        if (getUserResult && getUserResult.success) {
                            resolve({ success: true, data: getUserResult.data });
                        } else {
                            resolve({ success: false, data: getUserResult.data });
                        }
                    },
                    onFail: function (err) {
                        console.log(err.errorMessage )
                        resolve({ success: false, data: err.errorMessage });
                    }
                })
            })
        },
        ddReady() {
            return new Promise((resolve, reject) => {
                let jsapiArr = new Array();
                for (var i in jsapi) {
                    jsapi[i]
                        ? jsapiArr.push(i)
                        : ""
                };
                http.get(`api/UserManagement/GetAuthenticateConfig?url=${encodeURIComponent(window.location.href.split('#')[0])}&smallProgram=${dingdingAccessKey}`).then((res) => {
                    const data = res.data.data || {};
                    const config = {
                        agentId: data.agentId || '',
                        corpId: data.corpId || '',
                        timeStamp: data.timeStamp || '',
                        nonceStr: data.nonceStr || '',
                        signature: data.signature || '',
                        jsApiList: jsapiArr
                    }
                    dd.config(config);
                    dd.ready(function () {
                        resolve({ msg: '', data, success: true })
                    })
                    dd.error(function (error) {                       
                        resolve({});
                    });
                })
            })

        }
    }
    return await dingding.ddinit();
};

export default DingFun;


// WEBPACK FOOTER //
// ./src/utils/dingding/config.js